"use client";
import clsx from "clsx";
import { isPast } from "date-fns";
import { SlotComponentProps } from "../availabilities/types";
import { colors } from "../slot-color-configs";

export function SlotComponent({
	className,
	selectedCounterSlots,
	selectedSlot,
	slotValue,
	relationship,
}: SlotComponentProps) {
	const isBuyer = relationship === "buyer";
	const isSeller = relationship === "seller";

	// Show buyer badge if: we're buyer and selectedSlot, OR we're seller and selectedCounterSlots
	const showBuyer = (isBuyer && selectedSlot) || (isSeller && selectedCounterSlots);
	// Show seller badge if: we're seller and selectedSlot, OR we're buyer and selectedCounterSlots
	const showSeller = (isSeller && selectedSlot) || (isBuyer && selectedCounterSlots);
	const { badge, gradient } = colors;
	const buyerBadgeColor = badge[isBuyer ? "primary" : "secondary"];
	const sellerBadgeColor = badge[isSeller ? "primary" : "secondary"];
	const buyerSlotColor = badge[isBuyer ? "primary" : "secondary"];
	const sellerSlotColor = badge[isSeller ? "primary" : "secondary"];

	const gradientKey = `${isBuyer ? "primary" : "secondary"}-to-${isSeller ? "primary" : "secondary"}`;
	const matchingSlots = gradient[gradientKey as keyof typeof gradient];

	const defaultColor = isPast(new Date(slotValue)) ? "bg-white" : "";

	return (
		<div
			className={clsx("flex items-center justify-between w-full relative", className)}
			id={slotValue?.toString() || ""}
		>
			<div
				className={clsx(
					"w-full h-full absolute top-0 left-0 opacity-10 rounded-full",
					showBuyer && showSeller ? matchingSlots : showBuyer ? buyerSlotColor : showSeller ? sellerSlotColor : "",
				)}
			></div>
			{showBuyer || showSeller ? (
				<div className="flex items-center justify-between w-full flex-1">
					<div className="flex items-center p-1">
						{showBuyer && (
							<div
								className={clsx(
									"w-4 h-4 rounded-full text-white text-xs flex items-center justify-center font-small mix-blend-multiply",
									buyerBadgeColor,
								)}
							>
								B
							</div>
						)}
					</div>
					<div className="flex items-center p-1">
						{showSeller && (
							<div
								className={clsx(
									"w-4 h-4 rounded-full text-white text-xs flex items-center justify-center font-small mix-blend-multiply",
									sellerBadgeColor,
								)}
							>
								S
							</div>
						)}
					</div>
				</div>
			) : (
				<div className={clsx("w-full flex-1", defaultColor)}>&nbsp;</div>
			)}
		</div>
	);
}
